import { IVariant } from "@drone-parts.garphild.pro/interfaces";
import { Card, Col, Row } from "antd";

/* eslint-disable-next-line */
export interface ExpandedVariantsProps {
  variants: IVariant[];
}

export function ExpandedVariants({ variants }: ExpandedVariantsProps) {
  return (
    <Row gutter={8}>
      {variants.map((variant) => (
        <Col>
          <Card style={{ width: 150, marginBottom: 8 }}>
            <Row justify="space-between"><Col>Price</Col><Col>{variant.price / 100}</Col></Row>
            <Row justify="space-between"><Col>Delivery</Col><Col>{variant.delivery / 100}</Col></Row>
            <Row justify="space-between"><Col>Total</Col><Col>{(variant.price + variant.delivery) / 100}</Col></Row>
            <a href={variant.url} target="_blank" rel="noreferrer">Open</a>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default ExpandedVariants;
